var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCheckmark = function SvgCheckmark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#212121",
    d: "M5.167 4.606a1.32 1.32 0 0 1 0-1.827 1.226 1.226 0 0 1 1.771 0L12 8l-5.062 5.222a1.226 1.226 0 0 1-1.771 0 1.32 1.32 0 0 1 0-1.828L8.457 8z"
  })));
};
export { SvgCheckmark as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIGZpbGw9Im5vbmUiPgo8cGF0aCBkPSJNNS4xNjY3MSA0LjYwNjJDNC42Nzc1IDQuMTAxNTMgNC42Nzc1IDMuMjgzMjggNS4xNjY3MSAyLjc3ODZDNS42NTU5MiAyLjI3MzkzIDYuNDQ5MSAyLjI3MzkzIDYuOTM4MzEgMi43Nzg2TDExLjk5OTggOC4wMDAxTDYuOTM4MzEgMTMuMjIxNkM2LjQ0OTEgMTMuNzI2MyA1LjY1NTkzIDEzLjcyNjMgNS4xNjY3MSAxMy4yMjE2QzQuNjc3NSAxMi43MTY5IDQuNjc3NSAxMS44OTg3IDUuMTY2NzEgMTEuMzk0TDguNDU2NjEgOC4wMDAxTDUuMTY2NzEgNC42MDYyWiIgZmlsbD0iIzIxMjEyMSIvPgo8L3N2Zz4K";